import { useMemo } from 'react'
import { BaseTaskForm, TaskParams } from './BaseTaskForm'

interface MappingTableGeneratorFormProps {
  onChange: (task: TaskParams) => void
  withExamplePrefilled?: boolean
  defaultValue?: string
}

export function MappingTableGeneratorForm({
  onChange,
  withExamplePrefilled,
  defaultValue
}: MappingTableGeneratorFormProps) {
  // Use useMemo to recompute when withExamplePrefilled changes
  const initialDataweaveCode = useMemo(
    () =>
      defaultValue ||
      (withExamplePrefilled
        ? `
%dw 2.0
output application/json
---
{
  orderId: payload.orderId,
  totalCost: payload.items map ((item) -> {
    itemId: item.itemId,
    totalItemCost: vars.pricing[item.itemId] * item.quantity
  }),
}
          `.trim()
        : ''),
    [defaultValue, withExamplePrefilled]
  )

  return (
    <BaseTaskForm
      enter2Submit
      label='DataWeave script'
      onChange={onChange}
      minRows={20}
      disabled={withExamplePrefilled}
      placeholder={`
%dw 2.0
output application/json
---
{
  orderId: payload.orderId,
  totalCost: payload.items map ((item) -> {
    itemId: item.itemId,
    totalItemCost: vars.pricing[item.itemId] * item.quantity
  }),
}
          `.trim()}
      defaultValue={initialDataweaveCode}
    />
  )
}
